import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';

import { on } from '@ember/modifier';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';

interface Signature {
  Args: {
    form: ForcProviderBaseSignature['Blocks']['default'][0];
  };
}
export default class MiciBaseConsultFormAnalIncontinence extends Component<Signature> {
  clearChangeset = () => {
    if (!this.args.form.changeset.get('analIncontinence'))
      this.args.form.changeset.set('analIncontinenceFrequency', undefined);
  };

  <template>
    <@form.FieldsRadioGroup
      @propertyName='analIncontinence'
      @title={{t 'mici-form.analIncontinence.long' htmlSafe=true}}
      as |Group|
    >
      <Group.FieldRadio @value={{true}} @label='Oui' />
      <Group.FieldRadio
        @value={{false}}
        @label='Non'
        {{on 'click' this.clearChangeset}}
      />
    </@form.FieldsRadioGroup>
  </template>
}
